'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _utils = require('../helpers/utils');

var _cssClasses = require('../helpers/cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
/**
 * Component: Hotspot on mobile.
 * Used on the find your fit page
 * ------------------------------------------------------------------------------
 *
 * @namespace hotspot
 *
 */
var selectors = {
  target: '[js-hotspot="target"]',
  title: '[js-hotspot="title"]',
  close: '[js-hotspot="close"]'
};

/**
 * Export default toggle module.
 */

exports.default = function () {

  /**
   * Node selectors.
   */
  var nodeSelectors = {
    target: document.querySelectorAll(selectors.target),
    title: document.querySelectorAll(selectors.title),
    close: document.querySelectorAll(selectors.close)
  };

  /**
   * Initiate component.
   */
  function init() {
    setListeners();
  }

  /**
   * Set click events on toggle selectors.
   */
  function setListeners() {
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.target)).forEach(function (element) {
      (0, _utils.on)('click', element, function () {
        return hotspot(element);
      });
    });
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.close)).forEach(function (element) {
      (0, _utils.on)('click', element, function () {
        return hotspotsClose();
      });
    });
  }

  /**
   * Handle toggle events.
   * @param {Event} event Click event.
   */
  function hotspot(element) {
    var hotspotElm = document.querySelector('.' + element.dataset.hotspot);
    hotspotsClose();
    hotspotElm.classList.add(_cssClasses2.default.active);
  }

  function hotspotsClose() {
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.title)).forEach(function (item) {
      item.classList.remove(_cssClasses2.default.active);
    });
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init: init
  });
};